import {useEffect, useState} from 'react';

function useScrollbarWidth(){
    const [scrollbarWidth, setScrollbarWidth] = useState(0);
    useEffect(()=>{
        let scrollDiv = document.createElement("div");
		scrollDiv.className = "b-scrollbar";
		document.body.appendChild(scrollDiv);
		const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        setScrollbarWidth(scrollbarWidth);
    },[]);
    return scrollbarWidth;
}
export default useScrollbarWidth;